<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        :color="payload.ativo ? 'error' : 'success'"
        class="mr-3"
      >
        <v-icon v-if="payload.ativo">mdi-block-helper</v-icon>
        <v-icon v-if="!payload.ativo">mdi-restart</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <div style="font-size: 20px">
              Confirma que deseja
              {{ payload.ativo ? "inativar" : "reativar" }} o contrato
              <strong>{{ payload.numContrato }}</strong
              >?
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { contratosAPI } from "@/apis";

export default {
  name: "AppModalDeleteProject",
  props: {
    object: { type: Object, required: true },
  },
  data() {
    return {
      payload: {},
      dialog: false,
    };
  },
  mounted() {
    if (this.object) {
      this.payload = this.object;
    }
  },
  methods: {
    onConfirm() {
      this.payload.ativo = !this.payload.ativo;

      contratosAPI
        .ativarReativar({
          ativoInativo: this.payload.ativo,
          contratoid: this.payload.contratoId,
        })
        .then((resp) => {
          this.dialog = false;
          this.$emit("on-save");
        })
        .catch();
    },
  },
};
</script>
